import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { AlgoliaHit } from 'instantsearch.js';
import { useHits } from 'react-instantsearch';
import { SupplierHit } from '../search';
import { DiscoveryWordingsKeys } from '../discovery.utils';

export default function SearchBuyerCounts(): React.JSX.Element {
  const { results } = useHits<AlgoliaHit<SupplierHit>>();
  const { t } = useTranslation(['discovery']);

  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {!!results && (
        <Typography variant="bodyMedium" sx={{ color: 'onSurfaceVariant.main' }}>
          {t(DiscoveryWordingsKeys.SUPPLIER.n_result, { count: results?.nbHits })}
        </Typography>
      )}
    </>
  );
}
